/**
 * Announcements tour (ea/ulc Learner Portal) — Figma node 172-9937.
 *
 * A single-step introduction to the Announcements feature: it points at the
 * Announcements button in the dashboard header. Per the design there is no step
 * counter and no Skip — just a close (×) and a "Done" button (the engine renders a
 * minimal card automatically for single-step tours).
 *
 * Target hook `[data-tour="notifications-btn"]` is on DashboardNotificationDropdown.vue.
 */

import type { TourDefinition } from '../core/types';
import announcementsPreview from './assets/announcements-button-interaction.gif';

export const announcementsTour: TourDefinition = {
  id: 'announcements',
  version: 3,
  steps: [
    {
      target: '[data-tour="notifications-btn"]',
      title: 'Announcements',
      body: 'Stay up to date with the latest news, upcoming sessions, important deadlines, and program updates. Click here to open the announcements panel and view all recent updates.',
      image: announcementsPreview,
      imageAlt: 'Preview of the announcements panel',
      placement: 'bottom-end'
    }
  ]
};
